export * from "./deliveryStatus";
export * from "./financialReport";

export enum ApiRoutesEarnings {
  Earnings = "/admin/earnings",
  EarningsQuantities = "/admin/earnings/counts/broken-down-by-chapter",
  CancelEarnings = "/admin/earnings/cancel",
  PayEarnings = "/admin/earnings/pay",
  PayAllEarnings = "/admin/earnings/all/pay"
}

export enum ApiRoutesProfitAndLoss {
  ProfitAndLoss = "/admin/profit-and-loss"
}

export enum ApiRoutesFinancialReport {
  Summary = "/admin/profit-and-loss/summary",
  RevenueBreakdown = "/admin/profit-and-loss/revenue-breakdown",
  OtherCosts = "/admin/profit-and-loss/other-costs",
  Advertising = "/admin/profit-and-loss/advertising",
  Settings = "/admin/profit-and-loss/settings"
}

export enum ApiRoutesDeliveryFees {
  DeliveryFees = "admin/delivery/fees",
  DeliveryZone = "/admin/delivery/zones",
  DeliveryZoneExisting = "/admin/delivery/zones/exists",
  ParcelSizes = "/admin/delivery/settings",
  DeliveryLocations = "/admin/delivery/location",
  DeliveryLocationCountry = "/admin/delivery/location/country",
  DeliveryLocationCity = "/admin/delivery/location/country/city",
  DeliveryLocationArea = "/admin/delivery/location/country/city/area"
}

export enum ApiRoutesMobileMoneyBalance {
  MobileMoneyBalance = "/admin/payments/mobile-money/account/balance"
}

export enum ApiRoutesDeliveries {
  DriversDeliveriesInfo = "/admin/drivers/all-with-delivery-calculations",
  DriversDeliveriesReport = "/admin/drivers/deliveries-report",
  Driver = "/admin/drivers",
  DriverDeliveries = "with-deliveries",
  Deliveries = "/admin/order/deliveries",
  CollectMoney = "collect",
  PayDriver = "pay-to-driver"
}

export enum ApiRoutesInternalBank {
  Expenses = "admin/expenses",
  ExpensesStatistics = "statistics",
  InternalBank = "admin/internal-bank",
  InternalBankReplenish = "admin/internal-bank/replenish",
  InternalBankHistory = "admin/internal-bank/history-with-expenses",
  InternalBankReplenishment = "admin/internal-bank/history"
}

export enum ApiRoutesTransactions {
  Transactions = "/admin/transactions"
}

export enum ApiRoutesRefunds {
  Refunds = "/admin/refunds",
  Confirm = "refund"
}

export enum DeliveryZoneStatuses {
  Active = "Active",
  Inactive = "Inactive"
}

export const DELIVERY_ZONE_STATUSES_LIST = [
  {
    label: "Active",
    value: DeliveryZoneStatuses.Active,
    backgroundColor: "#16C350"
  },
  {
    label: "Inactive",
    value: DeliveryZoneStatuses.Inactive,
    backgroundColor: "#A8A8BB"
  }
];

export enum DeliveryType {
  Delivery = "Delivery",
  ReturnPickUpFromCustomer = "ReturnPickUpFromCustomer",
  ReturnDeliveryToCustomer = "ReturnDeliveryToCustomer"
}

export enum TransactionStatus {
  PaymentCollected = "PaymentCollected",
  CashCollectedFromDriver = "CashCollectedFromDriver",
  CashCollectedFromCustomer = "CashCollectedFromCustomer",
  EarningsSent = "EarningsSent",
  Refunded = "Refunded"
}

export enum EarningStatus {
  Pending = "Pending",
  Paid = "Paid",
  Canceled = "Canceled"
}

/**
 * What earned the money. Referral and influencer-promo commissions share one
 * type on the backend — both pay a referrer rather than the seller.
 */
export enum EarningType {
  ProductsReselling = "ProductsReselling",
  ProductsResellingByReferral = "ProductsResellingByReferral"
}

export enum EarningChapters {
  Pending = "Pending",
  AvailableToBePaid = "AvailableToBePaid",
  Paid = "Paid",
  Canceled = "Canceled"
}

export enum RefundType {
  OrderReturn = "OrderReturn",
  OrderEditing = "OrderEditing",
  OrderFailure = "OrderFailure",
  OrderCancellation = "OrderCancellation"
}

export enum InternalBankHistoryItemEntity {
  Expense = "Expense",
  InternalBankHistory = "InternalBankHistory"
}

export enum ExpenseMediaTypes {
  Proof = "Proof",
  ProofOfPayment = "ProofOfPayment"
}
